//basic
import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

//style
import '../parameters/Parameters.scss';
import theme from '../parameters/Autocomplete.scss';

//api
import { api } from '../../../../functions/api';

//custom components
// import Demo from '../../../../components/basic/SelectSearch/SelectSearch'; // Jozef - autosuggest
import SelectSearch from '../../../../components/basic/SelectSearch/SelectSearch';
import CustomInput from '../../../../components/basic/input';
import ChangeValues from '../../../parameters/ChangeValues/ChangeValues'

//material-ui
import { Paper, FormControl, InputLabel, Select, MenuItem, InputBase, CircularProgress } from '@material-ui/core';

//other libraries
import uuid from 'uuid4';
import Autosuggest from 'react-autosuggest';
import queryString from 'query-string'
import Icon from '@mdi/react'
import { mdiClose, mdiPencil } from '@mdi/js';


@inject('internal')
@inject('translate')
@observer
export default class Parameters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingBtn: false,
      changeParameterValues: false,
      idParam: 0,

      // data: STATIC_DATA,
      data: [],
      /**
       * list of rows, that contain 2 selects each
       */
      selectRows: [
        [
          // STATIC_DATA,
          {},
          null
        ]

      ]
    };
  }

  timeout = null;

  componentDidMount() {
    Promise.all([
      this.loadProducts(),
      this.loadBasicData()
    ]).then(() => {
      this.setState({ loading: false })
      this.updateOptions()
    }
    )
  }

  loadProducts = async (size = 10, page = 0, searchterm = " ", by = "name", dir = "asc", category_id = undefined) => {
    const URLqueryString = this.props.routerData.history.location.search
    let queries = queryString.parse(URLqueryString);

    let price = []
    let tags = [];
    let warehouse_status_id = null;
    let import_id = null;

    if (queries) {

      if (queries.page_number) {
        page = queries.page_number
      }

      if (queries.page_size) {
        size = queries.page_size
      }

      if (queries.by) {
        by = queries.by
      }

      if (queries.dir) {
        dir = queries.dir
      }

      if (queries.searchterm) {
        searchterm = queries.searchterm
      }

      if (queries.category_id) {
        category_id = queries.category_id
      }

      if (queries.price) {
        price = queries.price
      }

      if (queries.tags) {
        tags = queries.tags
      }

      if (queries.warehouse_status_id) {
        warehouse_status_id = queries.warehouse_status_id
      }

      if (queries.import_id) {
        import_id = queries.import_id
      }
    }

    let params = {
      searchterm: searchterm,
      page: {
        number: page,
        size: size
      },
      order: [
        {
          by: by,
          dir: dir
        },
        // {
        //     by: by,
        //     dir: dir
        // },
      ],
      //"filters[category_id]":
      //"filters[tags]": [tag]
    }

    let filters = {}
    if (category_id !== undefined) {
      let tmp = []
      tmp['category_id'] = Number(category_id)
      filters.category_id = Number(category_id)

      params.filters = filters
    }

    if (price.length > 0) {

      let tmp = []

      if (price.split(',')[1] === "" && price.split(',')[0] !== "") {
        let tmpRetailPrice = price;
        let tmp = tmpRetailPrice.split(',')
        // tmp[1] = 100000000
        let compareVal = tmp[0]
        tmp[0] = "gt"
        tmp[1] = compareVal
        price = tmp.join(',')
      }

      else if (price.split(',')[0] === "" && price.split(',')[1] !== "") {
        let tmpRetailPrice = price;
        let tmp = tmpRetailPrice.split(',')
        // tmp[0] = 0
        let compareVal = tmp[1]
        tmp[0] = "lt"
        tmp[1] = compareVal
        price = tmp.join(',')
      }

      else if (price.split(',')[0] === "" && price.split(',')[1] === "") {
        tmp[0] = "gte"
        price = tmp.join(',')
      }

      tmp['price'] = price.split(',')
      filters.price = tmp;
      params.filters = filters

    }

    if (tags.length > 0) {
      let tmp = []
      tmp['tags'] = tags.split(',')
      filters.tags = tmp
      params.filters = filters
    }

    if (warehouse_status_id !== null) {
      filters.warehouse_status_id = Number(warehouse_status_id)
      params.filters = filters

    }

    if (import_id !== null) {
      filters.import_id = Number(import_id)
      params.filters = filters
    }

    let load_data = await api({
      method: 'get',
      url: 'products',
      authorization: this.props.internal.user.access_token,
      params: params
    })


    if (load_data.success === true) {
      if (load_data.data) {

        for (let i = 0; i < load_data.data.data.length; i++) {
          let data = load_data.data.data[i].warehouse_status

          let category_name;
          if (load_data.data.data[i].category) {
            category_name = load_data.data.data[i].category.name
          }
          delete load_data.data.data[i].warehouse_status;
          load_data.data.data[i].warehouse_status_name = data.name
          load_data.data.data[i].category_name = category_name

          // load_data.data.lists.categories = this.categories.data
        }
        this.props.internal.setDataForTable(load_data.data)

      }
    }
  }

  loadBasicData = async () => {
    this.setState({ loading: true })
    let load_data = await api({
      method: 'get',
      url: 'products/' + this.props.routerData.match.params.idProduct,
      authorization: this.props.internal.user.access_token,
    })

    if (load_data.success && load_data.success === true) {

      let loaded_data = load_data.data.data
      let parameters = load_data.data.data.parameters
      let tmpParams = []
      for (let i in parameters) {
        if ((parameters[i].parameter_type_id === 1 || parameters[i].parameter_type_id === 2) && !parameters[i].hasOwnProperty('value')) {
          //zmene v pripadoch ked parameter mal value a neskor sa value zmazala, tak nezobrazuj ten parameter
        }
        else {
          tmpParams.push(parameters[i])
        }
      }
      loaded_data.parameters = tmpParams
      this.props.internal.setDataForSimpeTable(loaded_data)
    }

  }

  /**
   * called when parent (left) select changes its value
   */
  onParentSelectChange = (newValue, rowIndex) => {
    let selectedRows = this.state.selectRows;

    if (newValue === null) {
      selectedRows[rowIndex][0] = {};
      selectedRows[rowIndex][1] = null;
    }
    else {
      selectedRows[rowIndex][0] = newValue;
      selectedRows[rowIndex][1] = {};
    }
    this.setState({ selectRows: selectedRows })

  }

  /**
   * called when child (right) select changes its value
   */
  lastIndexRow = 0;
  onChildSelectChanged = (newValue, rowIndex) => {
    this.setState({ loadingBtn: true })
    let newSelectRows = this.state.selectRows

    if (this.state.selectRows[rowIndex][0].parameter_type_id === 2) {
      newSelectRows[rowIndex][1] = newValue;
    }
    else if (this.state.selectRows[rowIndex][0].parameter_type_id === 1) {
      newSelectRows[rowIndex][1] = [newValue];
    }


    this.lastIndexRow = this.state.selectRows.length

    if (rowIndex === this.lastIndexRow - 1) {
      newSelectRows.push([
        {},    // STATIC_DATA = same format, value and options for parent selects
        null
      ])
      this.lastIndexRow++
    }

    this.setState({ selectRows: newSelectRows })

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.updateParameter(this.state.selectRows[rowIndex])
    }, 2000)
  }

  textParams = {};
  
  addTextValueToParam = (rowIndex) => {
    // let newSelectRows = this.state.selectRows
    // newSelectRows[rowIndex][1] = {label: this.text_param.state.value, value: this.text_param.state.value};
    // this.lastIndexRow = this.state.selectRows.length

    // if(rowIndex === this.lastIndexRow - 1) {
    //   newSelectRows.push([
    //     {},
    //     null
    //   ])
    //   this.lastIndexRow++
    // }

    // this.setState({ selectRows: newSelectRows })

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      let newSelectRows = this.state.selectRows
      newSelectRows[rowIndex][1] = { label: this.textParams[rowIndex].state.value, value: this.textParams[rowIndex].state.value };
      this.lastIndexRow = this.state.selectRows.length

      if (rowIndex === this.lastIndexRow - 1) {
        newSelectRows.push([
          {},
          null
        ])
        this.lastIndexRow++
      }

      this.setState({ selectRows: newSelectRows })
      this.updateParameter(this.state.selectRows[rowIndex])
    }, 500)

  }

  updateParameter = async (parameterForUpdate) => {
    this.setState({ loadingBtn: true })
    let idProduct = this.props.routerData.match.params.idProduct


    let params = []
    let selected = this.state.selectRows
    for (let i = 0; i < selected.length - 1; i++) {
      let parameter_type_id = selected[i][0].parameter_type_id
      switch (parameter_type_id) {
        case 1:
          //signle
          if (selected[i][1][0]) {
            params.push({ parameter_id: selected[i][0].id, value: selected[i][1][0].parameter_item_id || selected[i][1][0].id })
          }
          break;
        case 2:
          //multi
          params.push({ parameter_id: selected[i][0].id, value: selected[i][1].map(val => Number(val.parameter_item_id) || Number(val.id)) }) //Number(val.parameter_item_id) ||
          break;
        case 3:
          //text
          if (selected[i][1].value !== "") {
            params.push({ parameter_id: selected[i][0].id, value: selected[i][1].value })
          }
          break;
      }
    }

    // products/:id/pair-parameters
    let update_data = await api({
      method: 'put',
      url: 'products/' + idProduct + "/pair-parameters",
      authorization: this.props.internal.user.access_token,
      params: params
    })

    // this.props.internal.setSnackbar("uspesne", true)
    if (update_data.success === true) {
      this.props.internal.setSnackbar(update_data.data.message, true)
      this.props.internal.setDataForSimpeTable(update_data.data.data)
      this.updateOptions()
    } else {
      if (422 === update_data.status) {
        this.props.internal.setSnackbar(this.props.translate.i18n.MODULES.PARAMETERS.VALUES_ERROR, true, true)
      } else {
        this.props.internal.setSnackbar(update_data.data.message, true, true)
      }
      this.setState({ loadingBtn: false })
    }

  }

  updateOptions = () => {
    const { dataForSimpeTable } = toJS(this.props.internal);
    const { dataForTable } = toJS(this.props.internal);

    if (dataForTable && dataForTable.lists && dataForTable.lists.parameters) {
      let listParameters = dataForTable.lists.parameters;
      for (let param in listParameters) {
        listParameters[param]['label'] = listParameters[param]['internal_name']
        listParameters[param]['value'] = listParameters[param]['id']
        if (listParameters[param].items.length) {
          let items = listParameters[param].items
          for (let item in items) {
            items[item]['value'] = items[item].id
            items[item]['label'] = items[item].name
          }
          listParameters[param]['values'] = items
        }
      }
      let used = false
      let parametersForOptions = []
      for (let indexParam = 0; indexParam < dataForTable.lists.parameters.length; indexParam++) {
        for (let indexUsedPram = 0; indexUsedPram < dataForSimpeTable.parameters.length; indexUsedPram++) {
          if (dataForSimpeTable.parameters[indexUsedPram].id === dataForTable.lists.parameters[indexParam].id) {
            used = true
          }
        }

        if (!used) {
          parametersForOptions.push(dataForTable.lists.parameters[indexParam])
        }
        used = false
      }

      // this.setState({data: listParameters})
      this.setState({ data: parametersForOptions })
    }

    // parametre priradene na produkt
    if (dataForSimpeTable && dataForSimpeTable.parameters) {
      let parameters = dataForSimpeTable.parameters;

      let selectedParams = []
      let i = 0;
      for (let param in parameters) {
        parameters[param]['values'] = parameters[param]['value']
        parameters[param]['label'] = parameters[param]['internal_name']
        parameters[param]['value'] = parameters[param]['internal_name']

        if (parameters[param].parameter_type_id === 2) {
          //multivalue
          let multipleParamValues = parameters[param].values
          for (let val in multipleParamValues) {
            parameters[param].values[val]['label'] = parameters[param].values[val].name
            parameters[param].values[val]['value'] = parameters[param].values[val].id
          }
          selectedParams.push([parameters[param], parameters[param].values])

          let listParams = dataForTable.lists.parameters; // list vsetkych parametrov

          let parameterForEdit = listParams.find(item => item.id === selectedParams[param][0].id) // parameter, ktoremu chceme pridat options (vsetky dalsie values)

          let selectedValues = parameters[param].values; //parameter_item_id
          let allParamValues = parameterForEdit.values

          let used = false
          let filtered = []
          for (let all in allParamValues) {
            for (let selected in selectedValues) {
              if (selectedValues[selected].parameter_item_id === allParamValues[all].id) {
                used = true
              }
            }
            if (!used) {
              filtered.push(allParamValues[all])
            }
            used = false
          }

          selectedParams[param][0].values = filtered
        }
        else if (parameters[param].parameter_type_id === 1) {
          //singlevalue
          parameters[param].values['label'] = parameters[param].values.name
          parameters[param].values['value'] = parameters[param].values.id
          parameters[param].values = [parameters[param].values] // options for single select has to be an array
          selectedParams.push([parameters[param], parameters[param].values])

          let listParams = dataForTable.lists.parameters; // list vsetkych parametrov

          let parameterForEdit = listParams.find(item => item.id === selectedParams[param][0].id) // parameter, ktoremu chceme pridat options (vsetky dalsie values)

          let allParamValues = parameterForEdit.values

          selectedParams[param][0].values = allParamValues

        }
        else if (parameters[param].parameter_type_id === 3) {
          //textparam
          let textValue = parameters[i].values
          delete parameters[i].values

          parameters[i]['values'] = { id: 0, label: textValue, value: textValue }
          selectedParams.push([parameters[i], parameters[i].values])
        }

        // selectedParams.push([parameters[i],parameters[param].values])
        i++

      }
      selectedParams.push([
        {},
        null
      ])
      this.setState({ selectRows: selectedParams, loadingBtn: false })

    }
  }

  handleDeleteParameter = (row, rowIndex) => {

    let tmpSelected = this.state.selectRows
    delete tmpSelected[rowIndex]
    tmpSelected = tmpSelected.filter(function (el) {
      if (el[1] !== undefined) {
        return el
      }
    });
    this.setState({ selectRows: tmpSelected }, () => {
      this.updateParameter()
    })
  }

  changeParameterValues = (row, rowIndex) => {
    const { user } = toJS(this.props.internal)
    if(user && user.data && user.data.permissions && user.data.permissions.lists_parameter_items && user.data.permissions.lists_parameter_items.view) {
      if(row !== 'close') {
        this.setState({changeParameterValues: !this.state.changeParameterValues, idParam: row[0].id})
      }
      else {
        this.setState({changeParameterValues: !this.state.changeParameterValues})
        this.componentDidMount()
      }
    }
    else {
        this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
    }
    
}

timeout2 = null
    handleScrollDown = () => {
        clearTimeout(this.timeout2)
        this.timeout2 = setTimeout(() => {
            let paper = document.getElementById('parametersTab')
            // paper.scrollTop = paper.scrollHeight
            paper.scroll( {
                top: paper.scrollHeight,
                left: 0,
                behavior: 'smooth'
            })
        }, 100)
    }

  render() {
    return (
      this.state.loading ?
        <CircularProgress className={'circular-progress'} />
        :
        <div>
          {/* dialog pre upravovanie hodnot vybraneho parametru */}
          {this.state.changeParameterValues &&
                        <ChangeValues
                            open={this.state.changeParameterValues}
                            onClose={() => this.changeParameterValues('close')}
                            title={this.props.translate.i18n.MODULES.PARAMETERS.EDIT_PARAMETER_VALUES}
                            id={this.state.idParam}
                        />
                    }
       
        <Paper className={'parameters-container'} id={'parametersTab'}>

          {this.state.selectRows.map((row, rowIndex) => {
            return (<div className={'flex space-between'} key={uuid()}>
              {row.map((select, i) => {
                return i % 2 === 0 ? (
                  this.state.loadingBtn && rowIndex === this.state.selectRows.length - 1 ?
                    <CircularProgress className={'updateParameter'} />
                    :
                    <SelectSearch
                      options={this.state.data}
                      key={`param-${i}`}
                      // onChange={this.onParentSelectChange}
                      onChange={val => this.onParentSelectChange(val, rowIndex)}
                      value={this.state.selectRows[rowIndex][0]}
                      className={'select-search'}
                      label={this.props.translate.i18n.MODULES.PARAMETERS.PARAMETER}
                      isDisabled={this.state.loadingBtn}
                      onMenuOpen={this.handleScrollDown}
                    />
                ) : (
                    select
                      ?
                      (
                        // <pre>{JSON.stringify(this.state.selectRows[rowIndex][0], null, 2)}</pre>
                        row[0].parameter_type_id < 3 ?
                          <SelectSearch
                            className={'select-search'}
                            // options={this.state.selectRows[rowIndex][0].items}
                            options={this.state.selectRows[rowIndex][0].values}
                            // this.state.selectRows[rowIndex][0].values

                            isMulti={row[0].parameter_type_id === 2}
                            key={`values-${i}`}
                            onChange={val => this.onChildSelectChanged(val, rowIndex)}
                            label={this.props.translate.i18n.MODULES.PARAMETERS.VALUE}

                            value={
                              this.state.selectRows[rowIndex][0].parameter_type_id === 2 && this.state.selectRows[rowIndex][1].length > 0 //ake je multiple a obsahuje nieco
                                ?
                                this.state.selectRows[rowIndex][1]
                                :
                                this.state.selectRows[rowIndex][0].parameter_type_id === 1 && this.state.selectRows[rowIndex][1].values //ak je
                                  ?
                                  this.state.selectRows[rowIndex][1]
                                  :
                                  null
                            }
                            onMenuOpen={this.handleScrollDown}
                          />
                          :
                          <CustomInput
                            key={`values-${i}`}
                            value={this.state.selectRows[rowIndex][1].value}
                            ref={ref => this.textParams[rowIndex] = ref}
                            type={'text'}
                            text={this.props.translate.i18n.MODULES.PARAMETERS.VALUE}
                            id={'text'}
                            pressedButton
                            onPressButton={() => this.addTextValueToParam(rowIndex)}
                            // change={() => this.addTextValueToParam(rowIndex)}
                            className={'textParamValue'}
                            multiline
                          />

                      )
                      :
                      null
                  )
              })}
              {/* <div className={'deleteParamIcon'} > */}
              <div className={'actionIcons'} >
                {rowIndex < this.state.selectRows.length - 1 ?
                  <div >
                    {row[0].parameter_type_id < 3 ?
                    <div className={'edit'} onClick={() => this.changeParameterValues(row, rowIndex)}>
                      <Icon path={mdiPencil} size={1} />
                    </div>
                    :
                    <div className={'emptyEditDiv'} ></div>
                    }
                    <div className={'delete'} onClick={() => this.handleDeleteParameter(row, rowIndex)}>
                      <Icon path={mdiClose} size={1} />
                    </div>
                  </div>
                  :
                  null
                }
              </div>
            </div>)
          })}


        </Paper>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/parameters/Parameters.js